(() => {
  const CONFIG = {
    giftVariantId: 53373638607137,

    qualifyingVariantIds: [
      49319515783457, // Saber Portable Kit
      49319605043489, // Saber Bubbler Kit
      49319354827041, // Saber Recycler Kit
      49319475118369, // Saber Solo

      51191641211169, // Trident V3
      51191686463777, // Signature Series Bundle

      50910016209185, // Saber Kits - Solo
      50910016110881, // Saber Kits - Bubbler
      50910016143649, // Saber Kits - Portable
      50910016176417  // Saber Kits - Recycler
    ],

    unlockParameter: 'carepack',
    storageKey: 'hitoki_care_pack',
    unlockHours: 168
  };

  let syncing = false;

  function root() {
    return window.Shopify?.routes?.root || '/';
  }

  /*
   * Store unlock for 48 hours.
   *
   * This allows someone to unlock the offer, browse around,
   * leave the site, and return before the offer expires.
   */
  function captureUnlock() {
    const params = new URLSearchParams(window.location.search);

    if (params.get(CONFIG.unlockParameter) === '1') {
      const expires =
        Date.now() + CONFIG.unlockHours * 60 * 60 * 1000;

      localStorage.setItem(
        CONFIG.storageKey,
        JSON.stringify({ expires })
      );
    }
  }

  function isUnlocked() {
    try {
      const stored = JSON.parse(
        localStorage.getItem(CONFIG.storageKey)
      );

      if (!stored?.expires) {
        return false;
      }

      if (Date.now() > stored.expires) {
        localStorage.removeItem(CONFIG.storageKey);
        return false;
      }

      return true;
    } catch {
      return false;
    }
  }

  async function getCart() {
    const response = await fetch(root() + 'cart.js', {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Could not retrieve cart.');
    }

    return response.json();
  }

  async function addCarePack() {
    const response = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: CONFIG.giftVariantId,
            quantity: 1,
            properties: {
              '_promotion': 'Hitoki $60 Care Pack'
            }
          }
        ]
      })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(
        error.description || 'Could not add Care Pack.'
      );
    }

    return response.json();
  }

  async function changeLine(lineKey, quantity) {
    const response = await fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    });

    if (!response.ok) {
      throw new Error('Could not update Care Pack.');
    }

    return response.json();
  }

  function refreshConceptCart(open = false) {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          open
        }
      })
    );
  }

  function cartHasQualifyingDevice(cart) {
    return cart.items.some(item =>
      CONFIG.qualifyingVariantIds.includes(
        Number(item.variant_id)
      )
    );
  }

  function getGiftLines(cart) {
    return cart.items.filter(
      item =>
        Number(item.variant_id) ===
        Number(CONFIG.giftVariantId)
    );
  }

  async function removeAllGiftLines(cart) {
    const gifts = getGiftLines(cart);

    for (const gift of gifts) {
      await changeLine(gift.key, 0);
    }
  }

  async function verifyGiftIsFree() {
    /*
     * Give Shopify a moment to recalculate the Buy X Get Y
     * discount after the gift has been inserted.
     */
    await new Promise(resolve => setTimeout(resolve, 250));

    const cart = await getCart();

    const gift = getGiftLines(cart)[0];

    if (!gift) {
      return false;
    }

    /*
     * final_line_price = amount actually being charged.
     *
     * If the Shopify discount did not make the Care Pack
     * free, remove it so the customer is never charged $59.98.
     */
    if (Number(gift.final_line_price) !== 0) {
      console.warn(
        'Hitoki Care Pack discount did not apply. Removing gift.'
      );

      await changeLine(gift.key, 0);

      refreshConceptCart(false);

      return false;
    }

    return true;
  }

  async function syncCarePack(openDrawer = false) {
    if (syncing) {
      return;
    }

    syncing = true;

    try {
      captureUnlock();

      let cart = await getCart();

      const unlocked = isUnlocked();
      const qualifies = cartHasQualifyingDevice(cart);
      let gifts = getGiftLines(cart);

      /*
       * Customer unlocked offer AND has qualifying device.
       */
      if (unlocked && qualifies) {

        // Add gift if missing.
        if (gifts.length === 0) {
          await addCarePack();

          const isFree = await verifyGiftIsFree();

          if (isFree) {
            refreshConceptCart(true);
          }

          return;
        }

        /*
         * Keep quantity at exactly 1.
         */
        if (gifts[0].quantity !== 1) {
          await changeLine(gifts[0].key, 1);
        }

        /*
         * Remove duplicate gift lines if they somehow occur.
         */
        if (gifts.length > 1) {
          for (let i = 1; i < gifts.length; i++) {
            await changeLine(gifts[i].key, 0);
          }
        }

        await verifyGiftIsFree();

        refreshConceptCart(openDrawer);

        return;
      }

      /*
       * If qualifying device is removed,
       * remove the promotional Care Pack.
       */
      if (!qualifies && gifts.length) {
        await removeAllGiftLines(cart);
        refreshConceptCart(false);
      }

    } catch (error) {
      console.error('Hitoki Care Pack GWP:', error);
    } finally {
      syncing = false;
    }
  }

  /*
   * Concept-supported events.
   */

  document.addEventListener('page:loaded', () => {
    syncCarePack(false);
  });

  document.addEventListener('ajaxProduct:added', () => {
    setTimeout(() => {
      syncCarePack(true);
    }, 150);
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      syncCarePack(false);
    }, 150);
  });

  /*
   * Basic browser fallback.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncCarePack(false);
    });
  } else {
    syncCarePack(false);
  }
})();